// ClientSideProvider.tsx
import React, { ReactNode, useState } from "react";
import {
  QueryClient,
  QueryClientConfig,
  QueryClientProvider,
} from "@tanstack/react-query";
import { RecoilRoot } from "recoil";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Definisikan tipe props untuk komponen
interface ClientSideProviderProps {
  children: ReactNode;
}
const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
      gcTime: 5 * 1000, //cacheTime
    },
  },
};

const ClientSideProvider: React.FC<ClientSideProviderProps> = ({
  children,
}) => {
  const [queryClient] = useState(() => new QueryClient(queryClientConfig));

  return (
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        {/* Ini akan menampilkan notifikasi toast */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
        />
        {children}
      </QueryClientProvider>
    </RecoilRoot>
  );
};

export default ClientSideProvider;
